import type { FunctionComponent } from "react";

import { ArticleMoreStories } from "~/components/article/article-more-stories";
import { page as postiesKidsPage } from "~/pages/posties/kids";
import type { articleMoreStoriesArticle$key } from "~/queries/__generated__/articleMoreStoriesArticle.graphql";

import {
  ArticleMoreStoriesContainer,
  ButtonLink,
  ButtonText,
  Container,
  StyledFooterImageContainer,
  StyledPeterAndPippaImage,
  StyledPeterAndPippaImageContainer,
} from "./styles";

export type Props = {
  className?: string;
  reference: articleMoreStoriesArticle$key;
};

export const PostiesArticleFooter: FunctionComponent<Props> = ({ className, reference }) => {
  const { pathname, query } = postiesKidsPage.route({});

  return (
    <Container className={className}>
      <ArticleMoreStoriesContainer>
        <ArticleMoreStories reference={reference} />
      </ArticleMoreStoriesContainer>
      <ButtonLink pathname={pathname} query={query}>
        <ButtonText>BACK TO HOMEPAGE</ButtonText>
      </ButtonLink>
      <StyledFooterImageContainer>
        <StyledPeterAndPippaImageContainer>
          <StyledPeterAndPippaImage />
        </StyledPeterAndPippaImageContainer>
      </StyledFooterImageContainer>
    </Container>
  );
};

PostiesArticleFooter.displayName = "PostiesArticleFooter";
